'use strict'

const isEmpty = (str) => {
  if (typeof (str) === 'string') {
    str = str.trim()
  }

  return ((str === undefined) ||
          (str === null) ||
          (str === '') ||
          (Array.isArray(str) === true && str.length === 0) ||
          (typeof (str) === 'object' && Object.keys(str).length === 0))
}

export default isEmpty
